import {z} from "zod"
import {Box2Like} from "@cm/math"

export const batchingDefinition = z.object({
    // number of patches in each dimension
    numPatches: z.object({
        x: z.number(),
        y: z.number(),
    }),
    // size of a patch in pixels
    patchSize: z.object({
        width: z.number(),
        height: z.number(),
    }),
})

export type Batching = z.infer<typeof batchingDefinition>

export const descriptorDefinition = z.object({
    width: z.number(),
    height: z.number(),
    channels: z.number(),
    batching: batchingDefinition.optional(),
})

export type Descriptor = z.infer<typeof descriptorDefinition>

export type Region = Box2Like
export type Regions = Region[]

export type MipLevelRegion = Region & {
    mipLevel: number
}
export type MipLevelRegions = MipLevelRegion[]
